/**
 * 倒计时组件（<5min 闪烁提醒，基于服务端时间差校正）
 */
import { useEffect, useState } from 'react';
import { useCountdown } from '@/utils/useCountdown';
import { formatClock } from '@/utils/format';

interface CountdownProps {
  endTime: string | number | Date | null | undefined;
  serverTimeOffset?: number;
  onExpire?: () => void;
  /** 文案前缀 */
  prefix?: string;
  /** 到期文案 */
  expiredText?: string;
  tone?: 'default' | 'gold';
}

export default function Countdown({
  endTime,
  serverTimeOffset = 0,
  onExpire,
  prefix,
  expiredText = '已结束',
  tone = 'default',
}: CountdownProps) {
  const [expiredFlag, setExpiredFlag] = useState(false);
  const { remainingSec, expired, restart } = useCountdown(endTime, {
    serverTimeOffset,
    enabled: !!endTime,
    onExpire: () => {
      setExpiredFlag(true);
      onExpire?.();
    },
  });

  // endTime 变化时重算（竞价延长后传新 endTime）
  useEffect(() => {
    setExpiredFlag(false);
    restart(endTime);
  }, [endTime, restart]);

  if (!endTime || expired || expiredFlag) {
    return <span className={`countdown countdown--${tone}`}>{expiredText}</span>;
  }

  const urgent = remainingSec <= 5 * 60;
  const cls = [
    'countdown',
    urgent ? 'countdown--urgent' : tone === 'gold' ? 'countdown--gold' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls}>
      {prefix ? <span className="countdown-unit">{prefix}</span> : null}
      {formatClock(remainingSec)}
      <span className="countdown-unit">后结束</span>
    </span>
  );
}
